module.exports = __webpack_public_path__ + "img/credit.8f6e9264.svg";